/* eslint linebreak-style: ["error", "unix"] */
import Modal from 'components/modals/modal/modal';
import CloseButtonWhite from 'components/buttons/button-close/close-button.white';
import useModalWithQueryParams from 'hooks/useModalWithQueryParams';
import { ModalQueryParams } from 'data/app';
import SectionTitle from 'components/section-title/section-title';
import PageForm from 'components/forms/form-page/form-page';
import { useModalStyles } from 'styles/modal.styles';

export default function CreatePageModal() {
  const classes = useModalStyles();

  // Modal
  const {
    isOpen,
    handleClose,
  } = useModalWithQueryParams(ModalQueryParams.CREATE_NEW_PAGE);

  return (
    <Modal className={classes.modal} open={isOpen} onClose={handleClose} closeButtonComponent={CloseButtonWhite} hasCloseButton>
      <SectionTitle>Criar página</SectionTitle>
      <PageForm
        onSuccess={handleClose}
      />
    </Modal>
  );
}
